// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U0hV","controls":"styles_controls__inJPi","charLimit":"styles_charLimit__2ohsb","input":"styles_input__3mwjH","send":"styles_send__QHOcw"};